export default "__VITE_ASSET__C058g9d3__"